/**
 * Clinic theme configuration for the activation page.
 * Keyed by institution name (must match custom:clinicInstitution in Cognito).
 * All logoUrl values MUST be same-origin relative paths — no external URLs.
 */

const clinicThemes = {
  'Kaiser Permanente': {
    primary: '#004B87',
    accent: '#0077C8',
    background: '#f0f6fc',
    logoUrl: '/clinic-logos/kaiser.svg',
    displayName: 'Kaiser Permanente',
  },
  'Stanford Health Care': {
    primary: '#8C1515',
    accent: '#B1040E',
    background: '#fdf5f5',
    logoUrl: '/clinic-logos/stanford.svg',
    displayName: 'Stanford Health Care',
  },
  'Health Restored': {
    primary: '#0170B9',
    accent: '#61CE70',
    background: '#f0f8fc',
    logoUrl: '/clinic-logos/health-restored.svg',
    displayName: 'Health Restored',
  },
};

const defaultTheme = {
  primary: '#111827',
  accent: '#3b82f6',
  background: '#f9fafb',
  logoUrl: null,
  displayName: null,
};

export function getClinicTheme(institution) {
  if (!institution) return defaultTheme;
  return clinicThemes[institution] || { ...defaultTheme, displayName: institution };
}

export default clinicThemes;
